import React from 'react'
import type { FollowMeProfile } from '@core/Areas/FollowMe/types'
import { FeedContainerStyled } from '@core/Areas/FollowMe/Components/Common/FollowMe.styles'
import type { BetOptions } from './types'
import { IncomingSharedBet, useIncomingSharedBet } from './Components/IncomingSharedBet'
import { PendingBets } from './Components/PendingBets'
import { MyCopiedBets } from './Components/MyCopiedBets'
import { ResultedBets } from './Components/ResultedBets'

export const ProfileBets: React.FC<{
  profile: FollowMeProfile
  setHasCopiedBets(hasBets: boolean): void
  setPendingCount(count: number | null): void
  setBetsOption(option: BetOptions): void
  selectedBetsOption: BetOptions
}> = ({ profile, setHasCopiedBets, setPendingCount, setBetsOption, selectedBetsOption }) => {
  const { incomingShare, shouldAutoOpenQuickbet } = useIncomingSharedBet({
    selectedBetsOption,
    setBetsOption,
  })

  return (
    <FeedContainerStyled>
      {incomingShare && (
        <IncomingSharedBet
          sharedBet={incomingShare}
          shouldAutoOpenQuickbet={shouldAutoOpenQuickbet}
        />
      )}

      {selectedBetsOption === 'Pending Shares' && (
        <PendingBets
          profileId={profile.id}
          incomingPostId={incomingShare?.postId}
          setPendingBetsCount={setPendingCount}
        />
      )}

      {selectedBetsOption === 'Resulted Shares' && (
        <ResultedBets profileId={profile.id} incomingPostId={incomingShare?.postId} />
      )}

      {selectedBetsOption === 'My Copies' && <MyCopiedBets setHasCopiedBets={setHasCopiedBets} />}
    </FeedContainerStyled>
  )
}
